module.exports = __webpack_public_path__ + "static/fonts/NotoSansCJKkr-Black.35d73e9.eot";